import a11yEmoji from "@fec/remark-a11y-emoji";
import slug from "remark-slug";
import toc from "remark-toc";
export var postPlugins = [a11yEmoji, slug, toc //
];